export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\"/><path fill=\"#fa4338\" fill-rule=\"nonzero\" d=\"M14.498 12.504h-.064c-.614-.34-1.652-4.195-2.286-8.507C11.68 1.94 9.898.503 7.815.503c-2.129 0-3.965 1.538-4.373 3.698-.425 4.21-1.29 8.015-1.847 8.303H1.5a.496.496 0 100 .992h4.05A2.504 2.504 0 008 15.5a2.504 2.504 0 002.45-2.004h4.048a.496.496 0 100-.992z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};